export default __webpack_public_path__ + "static/media/full3.618c37a6.png";